import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunStationDiscountPrice, deleteBairunStationDiscountPriceByIds, updateBairunStationDiscountPrice, findBairunStationDiscountPrice, getBairunStationDiscountPriceList } from '@/api/bairun/stationDiscountPrice'; //  此处请自行替换地址

import { getBairunUserGroupInfoAllListByLevel } from '@/api/bairun/userGroup'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import couponSelect from '@/components/couponSelect/couponSelect';

var _this;

var _ruleTypeId = 20000;
export default {
  name: 'StationDiscountInterval',
  components: {
    couponSelect: couponSelect
  },
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, format || 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      oilCodes = oilCodes + '';
      var oilCodeArr = oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    },
    getWeekNames: function getWeekNames(cycleDays) {
      cycleDays = cycleDays + '';
      var arr = cycleDays.split(',');
      var names = '';

      if (arr.length === 0 || arr.length === _this.weekOptions.length) {
        return '不限';
      }

      _this.weekOptions.map(function (o) {
        if (arr.includes(o.value + '')) {
          names += o.label + ',';
        }
      });

      return names.substr(0, names.length - 1);
    },
    getUserGroupNames: function getUserGroupNames(groupIds) {
      debugger;
      groupIds = groupIds + '';
      var groupArr = groupIds.split(',');
      var groupNames = '';

      if (groupArr.includes('-1')) {
        return '全部用户';
      }

      _this.userGroupOptions.map(function (group) {
        if (groupArr.includes(group.ID + '')) {
          groupNames += group.groupName + group.parentName + ',';
        }
      });

      return groupNames.substr(0, groupNames.length - 1);
    },
    getLeastOilMassNames: function getLeastOilMassNames(oilMass) {
      return oilMass === 0 ? '不限' : oilMass;
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getBairunStationDiscountPriceList,
      addVisible: false,
      updateVisible: false,
      viewVisible: false,
      type: '',
      multipleSelection: [],
      stationOptions: [],
      userGroupOptions: [],
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      stationIdChecked: [],
      weekOptions: [],
      weekCheckAll: false,
      weekChecked: [],
      dateRangeValueArr: [],
      timeRangeValueArr: ['00:00:00', '23:59:59'],
      formData: {},
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      couponFormData: {
        goodsType: '',
        dialogVisible: false,
        sellerId: '',
        selection: [],
        // 回显，如果有数据，组件默认勾选
        activityGoodsMoney: '0'
      },
      rules: {
        stationIdString: [{
          required: true,
          message: '请选择油站',
          trigger: 'blur'
        }],
        oilCodeString: [{
          required: true,
          message: '请选择油品',
          trigger: 'blur'
        }],
        userGroupId: [{
          required: true,
          message: '请选择会员群',
          trigger: 'blur'
        }],
        isAddTicket: [{
          required: true,
          message: '请选择券限制',
          trigger: 'blur'
        }],
        discount: [{
          type: 'number',
          required: true,
          message: '请输入优惠金额，金额必须大于等于0',
          trigger: 'blur',
          min: 0
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (!_this.dateRangeValueArr || _this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择日期'));
            } else {
              callback();
            }
          }
        }],
        weekChecked: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (!_this.weekChecked || _this.weekChecked.length <= 0) {
              callback(new Error('请选择每周时间'));
            } else {
              callback();
            }
          }
        }],
        timeRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (!_this.timeRangeValueArr || _this.timeRangeValueArr.length !== 2) {
              callback(new Error('请选择每天时间'));
            } else {
              callback();
            }
          }
        }]
      },
      updateRules: {
        discount: [{
          type: 'number',
          required: true,
          message: '优惠金额必须大于等于0',
          trigger: 'blur',
          min: 0
        }],
        isAddTicket: [{
          required: true,
          message: '请选择券限制',
          trigger: 'blur'
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (!_this.dateRangeValueArr || _this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择日期'));
            } else {
              callback();
            }
          }
        }],
        weekChecked: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (!_this.weekChecked || _this.weekChecked.length <= 0) {
              callback(new Error('请选择每周时间'));
            } else {
              callback();
            }
          }
        }],
        timeRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (!_this.timeRangeValueArr || _this.timeRangeValueArr.length !== 2) {
              callback(new Error('请选择每天时间'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getRule: function getRule() {
      switch (this.type) {
        case 'create':
          return this.rules;

        case 'update':
          return this.updateRules;

        default:
          break;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, userGroupOptions, userGroupArr;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getDict('oilCode');

              case 2:
                _this3.oilCodesOptions = _context3.sent;
                _context3.next = 5;
                return _this3.getDict('week');

              case 5:
                _this3.weekOptions = _context3.sent;
                _context3.next = 8;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 8:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 12;
                return getBairunUserGroupInfoAllListByLevel({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 12:
                userGroupOptions = _context3.sent;
                userGroupArr = [];
                userGroupOptions.data.list.forEach(function (item) {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach(function (item2) {
                      item2.parentName = '(' + item.groupName + ')';
                    });
                    userGroupArr = userGroupArr.concat(item.children);
                  } else {
                    item.parentName = '';
                    userGroupArr.push(item);
                  }
                });
                _this3.userGroupOptions = userGroupArr;
                _this3.searchInfo.ruleTypeId = _ruleTypeId;
                _this3.formData = _this3.initData();
                _context3.next = 20;
                return _this3.getTableData();

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      return {
        ruleTypeId: _ruleTypeId,
        discountTitle: '',
        stationId: '',
        stationIdString: '',
        oilCode: '',
        oilCodeString: '',
        discount: 0,
        leastOilMass: 0,
        dateStart: '',
        dateEnd: '',
        timeStart: '',
        timeEnd: '',
        cycleDays: '',
        isAddTicket: 1,
        sysUserId: 0,
        sysUserName: '',
        discountPriceTicketList: []
      };
    },
    onSearch: function onSearch() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.ruleTypeId = _ruleTypeId;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSearch();
    },
    onClose: function onClose() {
      this.addVisible = false;
      this.updateVisible = false;
      this.viewVisible = false;
      this.dateRangeValueArr = [];
      this.timeRangeValueArr = ['00:00:00', '23:59:59'];
      this.weekChecked = [];
      this.weekCheckAll = false;
      this.stationIdChecked = [];
      this.oilCodesChecked = [];
      this.oilCodesCheckAll = false;
      this.formData = this.initData();
    },
    // 添加优惠券
    onAddTicket: function onAddTicket() {
      this.couponFormData.dialogVisible = true;
    },
    // 删除优惠券
    onDelActivityTicket: function onDelActivityTicket(row) {
      debugger;
      var that = this;
      that.formData.discountPriceTicketList = that.formData.discountPriceTicketList.filter(function (item) {
        return item.ticketRuleNo != row.ticketRuleNo;
      });
    },
    // 选择优惠券-确定
    ticketSelDialogOk: function ticketSelDialogOk(res) {
      var that = this;
      that.couponFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          var isExit = false;
          that.formData.discountPriceTicketList.forEach(function (item2) {
            if (item2.ticketRuleNo == item.ticketRuleNo) {
              isExit = true;
            }
          });

          if (!isExit) {
            that.formData.discountPriceTicketList.push(JSON.parse(JSON.stringify(item)));
          }
        });
      }
    },
    // 选择优惠券-关闭
    ticketDialogClose: function ticketDialogClose() {
      this.couponFormData.dialogVisible = false;
    },
    onView: function onView() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;

                if (!(that.multipleSelection.length === 0)) {
                  _context4.next = 4;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });
                return _context4.abrupt("return");

              case 4:
                _context4.next = 6;
                return findBairunStationDiscountPrice({
                  ID: that.multipleSelection[0].ID
                });

              case 6:
                res = _context4.sent;

                if (res.code === 0) {
                  that.formData = res.data.resBairunStationDiscountPrice;
                  that.weekChecked = that.formData.cycleDays === '' ? [] : that.formData.cycleDays.split(',').map(Number);
                  that.weekCheckAll = that.weekChecked.length === that.weekOptions.length;
                  that.dateRangeValueArr = [that.$options.filters.formatDate(that.formData.dateStart), that.$options.filters.formatDate(that.formData.dateEnd)];
                  that.timeRangeValueArr = [that.formData.timeStart, that.formData.timeEnd];
                  that.type = 'view';
                  that.viewVisible = true;
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onAdd: function onAdd() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.type = 'create';
                _this5.addVisible = true;

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onUpdate: function onUpdate() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;

                if (!(that.multipleSelection.length === 0)) {
                  _context6.next = 4;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });
                return _context6.abrupt("return");

              case 4:
                if (!(that.multipleSelection.length > 1)) {
                  _context6.next = 7;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: '只能选择一条数据'
                });
                return _context6.abrupt("return");

              case 7:
                _context6.next = 9;
                return findBairunStationDiscountPrice({
                  ID: that.multipleSelection[0].ID
                });

              case 9:
                res = _context6.sent;

                if (res.code === 0) {
                  that.formData = res.data.resBairunStationDiscountPrice;
                  that.weekChecked = that.formData.cycleDays === '' ? [] : that.formData.cycleDays.split(',').map(Number);
                  that.weekCheckAll = that.weekChecked.length === that.weekOptions.length;
                  that.dateRangeValueArr = [that.$options.filters.formatDate(that.formData.dateStart), that.$options.filters.formatDate(that.formData.dateEnd)];
                  that.timeRangeValueArr = [that.formData.timeStart, that.formData.timeEnd];
                  that.type = 'update';
                  that.updateVisible = true;

                  if (!that.formData.discountPriceTicketList) {
                    that.formData.discountPriceTicketList = [];
                  }
                }

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onBatchDelete: function onBatchDelete() {
      var _this7 = this;

      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择要操作的数据'
        });
        return;
      }

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.handleDeletes();
      }).catch(function (err) {});
    },
    onDialogSubmit: function onDialogSubmit() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, discountPriceTicketList;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this8;
                discountPriceTicketList = []; // 优惠券

                console.log(that.formData);
                _context7.t0 = that.type;
                _context7.next = _context7.t0 === 'create' ? 6 : _context7.t0 === 'update' ? 21 : 25;
                break;

              case 6:
                if (_this8.checkParam()) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return");

              case 8:
                that.formData.oilCode = 0;
                that.formData.stationId = 0;
                that.formData.stationIdString = that.stationIdChecked.join(',');
                that.formData.oilCodeString = that.oilCodesChecked.join(',');
                that.formData.cycleDays = that.weekChecked.join(',');
                that.formData.dateStart = that.dateRangeValueArr[0];
                that.formData.dateEnd = that.dateRangeValueArr[1];
                that.formData.timeStart = that.timeRangeValueArr[0];
                that.formData.timeEnd = that.timeRangeValueArr[1];
                that.formData.discountPriceTicketList.forEach(function (item) {
                  discountPriceTicketList.push({
                    'ticketRuleNo': item.ticketRuleNo
                  });
                });
                that.formData.discountPriceTicketList = discountPriceTicketList;
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    createBairunStationDiscountPrice(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context7.abrupt("break", 26);

              case 21:
                if (_this8.checkParam()) {
                  _context7.next = 23;
                  break;
                }

                return _context7.abrupt("return");

              case 23:
                that.$refs['updateFormData'].validate(function (valid) {
                  that.formData.cycleDays = _this8.weekChecked.join(',');
                  that.formData.dateStart = _this8.dateRangeValueArr[0];
                  that.formData.dateEnd = _this8.dateRangeValueArr[1];
                  that.formData.timeStart = _this8.timeRangeValueArr[0];
                  that.formData.timeEnd = _this8.timeRangeValueArr[1];

                  if (that.formData.isAddTicket == 3) {
                    that.formData.discountPriceTicketList.forEach(function (item) {
                      discountPriceTicketList.push({
                        'ticketRuleNo': item.ticketRuleNo
                      });
                    });
                    that.formData.discountPriceTicketList = discountPriceTicketList;
                  } else {
                    that.formData.discountPriceTicketList = [];
                  }

                  if (valid) {
                    updateBairunStationDiscountPrice(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context7.abrupt("break", 26);

              case 25:
                return _context7.abrupt("break", 26);

              case 26:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    checkParam: function checkParam() {
      if ([3].includes(this.formData.isAddTicket) && (!this.formData.discountPriceTicketList || !this.formData.discountPriceTicketList.length)) {
        this.$message({
          type: 'warning',
          message: '请选择可用优惠券'
        });
        return false;
      }

      return true;
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.onClose();
        this.getTableData();
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCheckWeekAllChange: function handleCheckWeekAllChange(val) {
      this.weekChecked = val ? this.weekOptions.map(function (w) {
        return w.value;
      }) : [];
      this.weekCheckAll = this.weekChecked.length === this.weekOptions.length;
    },
    handleCheckedWeekChange: function handleCheckedWeekChange(value) {
      this.weekCheckAll = value.length === this.weekOptions.length;

      if (this.weekCheckAll) {
        this.handleCheckWeekAllChange(true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (oil) {
        return oil.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;
    },
    handleCheckedOilCodesChange: function handleCheckedOilCodesChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleCheckAllChange(true);
      }
    },
    handleDeletes: function handleDeletes() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ids = [];
                _this9.multipleSelection && _this9.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context8.next = 4;
                return deleteBairunStationDiscountPriceByIds({
                  ids: ids
                });

              case 4:
                res = _context8.sent;

                if (res.code === 0) {
                  _this9.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this9.tableData.length === ids.length && _this9.page > 1) {
                    _this9.page--;
                  }

                  _this9.getTableData();
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  }
};